import { render, staticRenderFns } from "./UpdateTyreStatus.vue?vue&type=template&id=61637e6a&scoped=true&"
import script from "./UpdateTyreStatus.vue?vue&type=script&lang=js&"
export * from "./UpdateTyreStatus.vue?vue&type=script&lang=js&"
import style0 from "./UpdateTyreStatus.vue?vue&type=style&index=0&id=61637e6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61637e6a",
  null
  
)

export default component.exports